import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Appointment = () => {
  const [appointments, setAppointments] = useState([]);
  const [selectedNote, setSelectedNote] = useState('');
  const [showNoteModal, setShowNoteModal] = useState(false);

  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  const fetchAppointments = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/appointments`);
      setAppointments(res.data);
    } catch (error) {
      console.error("Failed to fetch appointments", error);
    }
  };

  const handleDelete = async (id) => {
    if (!confirm("Are you sure you want to delete this Appointment?")) return;

    try {
      await axios.delete(`${API_BASE}/api/appointments/${id}`);
      fetchAppointments();
    } catch (error) {
      console.error("Failed to delete appointment", error);
    }
  };

  const handleNoteClick = (note) => {
    setSelectedNote(note);
    setShowNoteModal(true);
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  return (
    <div className="w-full flex flex-col gap-8">
      <div className="w-full flex flex-col gap-4 bg-[#00294B] rounded-md">
        <h2 className="px-4 pt-4 text-2xl font-bold text-white">Appointments</h2>

        <div className="w-full flex flex-col gap-4 p-4 min-h-[20rem]">
          {appointments.length === 0 ? (
            <h4 className="text-xl font-semibold text-white text-center">
              No appointment found.
            </h4>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-[#022C4E] text-white rounded-md overflow-hidden">
                <thead>
                  <tr className="bg-[#00406B] text-left">
                    <th className="py-3 px-4">ID</th>
                    <th className="py-3 px-4">Name</th>
                    <th className="py-3 px-4">Phone Number</th>
                    <th className="py-3 px-4">Service</th>
                    <th className="py-3 px-4">Note</th>
                    <th className="py-3 px-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {appointments.map((a) => (
                    <tr key={a.id} className="border-b border-[#1a3c5a]">
                      <td className="py-3 px-4">{a.id}</td>
                      <td className="py-3 px-4">{a.name}</td>
                      <td className="py-3 px-4">{a.mobile}</td>
                      <td className="py-3 px-4">{a.service}</td>
                      <td
                        className="py-3 px-4 cursor-pointer text-blue-300 underline"
                        onClick={() => handleNoteClick(a.note)}
                      >
                        {a.note
                          ? a.note.split(" ").slice(0, 5).join(" ") + (a.note.split(" ").length > 5 ? '...' : '')
                          : '—'}
                      </td>
                      <td className="py-3 px-4">
                        <button
                          onClick={() => handleDelete(a.id)}
                          className="bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Note Modal */}
      {showNoteModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-md shadow-lg max-w-md w-full p-6 relative">
            <button
              onClick={() => setShowNoteModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl font-bold"
            >
              ×
            </button>
            <h3 className="text-lg font-semibold mb-4 text-center">সম্পূর্ণ নোট</h3>
            <div className='max-h-[25rem] overflow-auto'>
                 <p className="text-gray-800 whitespace-pre-line">{selectedNote}</p>

            </div>
           
          </div>
        </div>
      )}
    </div>
  );
};

export default Appointment;
